export const NEW_FILE_TYPE_ALL = 'NEW_FILE_TYPE_ALL';
export const NEW_FILE_TYPE_WITH_PAYMENT = 'NEW_FILE_TYPE_WITH_PAYMENT';
